import { render, staticRenderFns } from "./ProductDetailCommentTab.vue?vue&type=template&id=36459290&"
import script from "./ProductDetailCommentTab.vue?vue&type=script&lang=js&"
export * from "./ProductDetailCommentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports